import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/work-calendar/me/")({
  head: () => ({
    meta: [{ title: "我的工作日历 · imiker CRM" }],
  })
});
